"use strict";
/* globals module */
/**
 * @module companyBatchClient
 * @description  Company Batch Client provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Company Route Service to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var inversify_1 = require("inversify");
var httpApi_1 = require("../../httpApi");
var _1 = require("./");
var CompanyBatchClient = /** @class */ (function () {
    function CompanyBatchClient(companyBatchRoute, apiClient) {
        this.companyBatchRoute = companyBatchRoute;
        this.apiClient = apiClient;
    }
    Object.defineProperty(CompanyBatchClient.prototype, "routeDefinition", {
        get: function () {
            return this.companyBatchRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the create company action has been performed; this action creates new company resources.
     * @method
     * @param data A collection of company objects that need to be inserted into the system.
     * @returns A promise that is resolved once the create company action has been performed.
     * @example  companyBatchClient.create([{
                    description : '<description>',
                    name : '<name>',
                    slug: '<slug>'
                 }])
                 .then(function (data) {
                     // perform success action here
                  },
                   function (response, status, headers, config) {
                       // perform error handling here
                 });
     **/
    CompanyBatchClient.prototype.create = function (data) {
        return this.apiClient.post(this.routeDefinition.create(), this.routeDefinition.createParams(data));
    };
    /**
     * Returns a promise that is resolved once the update company action has been performed; this action updates specified company resources.
     * @method
     * @param data A collection of company objects used to update specified company resources.
     * @returns A promise that is resolved once the update company action has been performed.
     * @example   companyBatchClient.update(companies)
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     **/
    CompanyBatchClient.prototype.update = function (data) {
        return this.apiClient.put(this.routeDefinition.update(), this.routeDefinition.updateParams(data));
    };
    /**
     * Returns a promise that is resolved once the remove action has been performed. This action will remove company resources from the system if successfully completed.
     * @method
     * @param ids Collection of company ids which uniquely identifies company resources that need to be deleted.
     * @returns A promise that is resolved once the remove action has been performed.
     * @example companyBatchClient.remove(companyIds)
                   .then(function (data) {
                       // perform success action here
                   },
                    function (response, status, headers, config) {
                        // perform error handling here
                   });
    **/
    CompanyBatchClient.prototype.remove = function (ids) {
        return this.apiClient.delete(this.companyBatchRoute.delete(), undefined, ids);
    };
    var _a, _b;
    CompanyBatchClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.CompanyBatchRoute)),
        tslib_1.__param(1, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.CompanyBatchRoute !== "undefined" && _1.CompanyBatchRoute) === "function" ? _a : Object, typeof (_b = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _b : Object])
    ], CompanyBatchClient);
    return CompanyBatchClient;
}());
exports.CompanyBatchClient = CompanyBatchClient;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route service.
 */ 
